import styled from 'styled-components'

const Title = styled.div`
  font-size: 18px;
  line-height: 26px;
  width: 480px;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Content = styled.div`
  padding: 28px 32px 32px 32px;
`

export const s = {
  Title,
  Content
}
